<section class="relevant-article-section">
  <div class="container">
    <h2 class="section-title">More News Articles</h2>

    <div class="row g-4 justify-content-center">
      <!-- Loop through the 3 random news articles -->
      <div class="col-lg-4 col-md-6" *ngFor="let article of relevantNewsArticles">
        
        <!-- The entire card is clickable and navigates to the correct route -->
        <div class="article-card" (click)="navigateTo(article.route)">
          <img [src]="article.image" [alt]="article.title" class="card-image">
          <div class="card-content">
            <h5 class="card-title">{{ article.title }}</h5>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>